/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Button,
  Input,
  Col,
  Card,
  Spin,
  DatePicker,
  Menu,
  Modal,
  message,
} from 'antd';
import {
  CloseCircleOutlined,
  DollarOutlined,
  FileExcelOutlined,
  DownloadOutlined,
  MinusCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import Table from 'components/Table';
import Select from 'components/Select';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import { onError, onSuccess } from 'utils/handlers';
import HTTP, { baseURL } from 'utils/api';
import {
  getAreas,
  getTiposDeEmpleados,
} from 'api/catalogos/index';
import { checkToken } from 'api/utils';
import {
  getRetencionDePago,
  getRetencionesDePagos,
  patchRetencionDePago,
  postRetencionDePago,
  putRetencionesDePagos,
  putCancelacionesDePagos,
  putLiberacionesDePagos,
  deleteRetencionesDePagos,
  getRetencionDePagoPlantilla,
} from 'api/nominas/retencion/retencionDePagos';
import FormSubmitControls from 'components/FormSubmitControls';
import { getEmpleado, getEmpleadosConDatosOpFilteredPaginated, getEmpleadosFiltered } from 'api/estructuraOrganizacional/empleados';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getPuestos } from 'api/catalogos/puestos';
import { getPlazas, getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getMotivosRetencionDePagos } from 'api/catalogos/motivosDeRetencionDePagos';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getAdministracionDePlazas, getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import ModalDelete from 'components/ModalDelete';
import { getEstadosDeRetenciones } from 'api/nominas/retencion/estadosDeRetencionDePagos';
import {
  ESTADO_PAGO_LIBERADO,
  ESTADO_PAGO_RETENIDO,
  ESTADO_PAGO_CANCELADO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import ModalFechaObservacion from 'components/ModalFechaObservacion';
import Dragger from 'components/Dragger';
import ModalConfirmation from 'components/ModalConfirmation';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import CustomSearch from 'components/customSearch';

export const retencionDePagosPermission = {
  permissionModel: ['retenciondepagoempleado'],
  catalogsModels: [],
  tabsModels: [],
};

const baseURI = 'nominas/retenciones-empleados-importar-excel';

const NominasRetencionDePagos = ({ permission }) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [formModal] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openRetener, setOpenRetener] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [formCarga] = Form.useForm();

  const [data, setData] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [empleadosDatosOperacionales, setEmpleadosDatosOperacionales] = useState([]);
  // const [tiposDeEmpleados, setTiposDeEmpleados] = useState([]);
  // const [puestos, setPuestos] = useState([]);
  // const [administracionDePlazas, setAdministracionDePlazas] = useState([]);
  // const [areas, setAreas] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [motivosDeRetencionDePagos, setMotivosDeRetencionDePagos] = useState([]);
  const [periodosDeNominas, setPeriodosDeNominas] = useState([]);
  const [periodosDeNominaDetalles, setPeriodosDeNominasDetalles] = useState([]);
  const [periodosDeNominaDetallesFiltered, setPeriodosDeNominaDetallesFiltered] = useState([]);
  const [estadosDeRetenciones, setEstadosDeRetenciones] = useState([]);
  const [claveNombreEmpleado, setClaveNombreEmpleado] = useState('');
  const [title, setTitle] = useState('');
  const [canceladoLiberado, setCanceladoLiberado] = useState();
  const [canRetener, setCanRetener] = useState(false);
  const [cancLib, setCancLib] = useState(false);
  const [disableEdit, setDisableEdit] = useState(false);
  const [disableDelete, setDisableDelete] = useState(false);
  // const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  // const [openSearch, setVisibleSearch] = useState(false);
  // const [dataSearch, setDataSearch] = useState([]);
  // const [baseURIPagination, setBaseURIPagination] = useState();
  // const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();

  const nameEmpleado = 'empleado';
  const nameTipoEmpleado = 'tipo_empleado';
  const namePuesto = 'puesto';
  const nameArea = 'area';
  const namePlaza = 'plaza';

  const getPlaza = (idEmpleado) => {
    const _datoOperacional = empleadosDatosOperacionales?.find((e) => e.empleado === idEmpleado);
    const idPlaza = _datoOperacional?.plaza;
    return ({
      _plaza: plazas?.find((p) => p.id === idPlaza),
      _datoOp: _datoOperacional,
    });
  };

  const watcherEmpleado = Form.useWatch(nameEmpleado, form);
  useEffect(() => {
    if (!watcherEmpleado) { return; }
    const { _plaza, _datoOp } = getPlaza(watcherEmpleado);

    const areaStr = _plaza?.directorio_area_clave_y_nombre || '';
    const plazaStr = _plaza?.clave_y_descripcion || '';
    const puestoStr = _plaza?.puesto_clave_y_descripcion || '';
    const tipoNomina = _plaza?.tipo_nomina_empleado || '';
    const fieldsValues = {
      [namePlaza]: plazaStr,
      [namePuesto]: puestoStr,
      [nameArea]: areaStr,
      [nameTipoEmpleado]: tipoNomina,
    };
    const _periodos = periodosDeNominas?.find((e) => e.tipo_de_nomina_empleado === _datoOp?.tipo_de_nomina_empleado);
    const _periodosDetallesFiltered = periodosDeNominaDetalles?.filter((e) => e.periodo_de_nomina === _periodos?.id);

    form.setFieldsValue(fieldsValues);
    setPeriodosDeNominaDetallesFiltered(_periodosDetallesFiltered);
  }, [watcherEmpleado]);

  // let baseURIDatosOpPaginado = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  const formInstances = [
    form,
    formDatos,
  ];

  // const formatReceivedClone = (values) => {
  //   if (Array.isArray(values)) {
  //     let valueClone = values.map((e) => formatReceivedValues(e));
  //     valueClone = valueClone.map((e) => ({
  //       ...e,
  //       empleado_tipo: e?.empleado,
  //       empleado_puesto: e?.empleado,
  //       empleado_area: e?.empleado,
  //       empleado_nPlaza: e?.empleado,
  //     }));
  //     return valueClone;
  //   }
  //   return formatReceivedValues(values);
  // };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getRetencionesDePagos();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    const selectedData = data.filter((item) => selectedRowKeys.includes(item.id));
    const estadosRetencion = selectedData.map((item) => item.estado_retencion);

    const activos = estadosRetencion.every((estado) => estado === 1);
    const retenidos = estadosRetencion.every((estado) => estado === 3);

    const validacionRetener = activos;
    const validacionCancelarLiberar = retenidos;

    if (estadosRetencion.length === 0) {
      setCanRetener(false);
      setCancLib(false);
      setDisableEdit(false);
      setDisableDelete(false);
    } else {
      setCanRetener(validacionRetener);
      setCancLib(validacionCancelarLiberar);
      setDisableEdit(estadosRetencion.includes(2) || estadosRetencion.includes(4));
      setDisableDelete(estadosRetencion.includes(2) || estadosRetencion.includes(4));
    }
  }, [selectedRowKeys]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _empleados,
        _datosOperacionalesEmpleados,
        // _tiposDeEmpleados,
        // _puestos,
        _administracionDePlazas,
        // _areas,
        _plazas,
        _motivosDeRetencionDePagos,
        _periodosDeNominas,
        _periodosDeNominasDetalle,
        _estadosDeRetenciones,
        // _tipos_de_nominas_empleados,
        _data,
      ] = await Promise.all([
        getEmpleadosFiltered(),
        getDatoOperacionalesDeEmpleados(),
        // getTiposDeEmpleados(),
        // getPuestos(),
        getAdministracionDePlazasvistaOptimized(),
        // getAreas(),
        getPlazasvistaOptimized(),
        getMotivosRetencionDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominas({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominasDetalles(),
        getEstadosDeRetenciones(),
        // getTiposDeNominasEmpleados(),
        getRetencionesDePagos(),
      ]);
      // const normalizedData = normalizeData(_areas);
      if (mounted) {
        setEmpleadosDatosOperacionales(_datosOperacionalesEmpleados);
        // setTiposDeEmpleados(_tiposDeEmpleados);
        // setPuestos(_puestos);
        // setAdministracionDePlazas(_administracionDePlazas);
        const empleadosFiltrados = _empleados?.filter((empleado) => _administracionDePlazas?.some((plaza) => plaza?.empleado_id === empleado?.id));
        setEmpleados(empleadosFiltrados);
        // setAreas(normalizedData);
        setPlazas(_plazas);
        setMotivosDeRetencionDePagos(_motivosDeRetencionDePagos);
        setPeriodosDeNominas(_periodosDeNominas);
        setPeriodosDeNominasDetalles(_periodosDeNominasDetalle.filter((periodosNomDetalle) => _periodosDeNominas.some((periodoNomina) => periodoNomina.id === periodosNomDetalle?.periodo_de_nomina)));
        setPeriodosDeNominaDetallesFiltered(_periodosDeNominasDetalle);
        setEstadosDeRetenciones(_estadosDeRetenciones);
        // setTiposDeNominaEmpleado(_tipos_de_nominas_empleados);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    // setSelectedEmpleadoSearch();
    setVisible(false);
    // setVisibleSearch(false);
    setVisibleAlert(false);
    setOpenModal(false);
    setTitle('');
    setCanceladoLiberado();
    setOpenRetener(false);
    form.resetFields();
    formModal.resetFields();
  };

  // const onChangeEmpleado = (empleado_id) => {
  //   form.resetFields([
  //     'tipo_de_empleado',
  //     'puesto',
  //     'area',
  //     'plaza',
  //     'periodo_de_nomina_retenido',
  //     'periodo_de_nomina_retencion',
  //   ]);
  //   if (empleado_id) {
  //     const {
  //       tipo_de_nomina_empleado,
  //     } = empleadosDatosOperacionales.find((empleadoDato) => empleadoDato.empleado === empleado_id);

  //     //* Tipo de empleado
  //     const _adminPlaza = administracionDePlazas?.find((adminPlaza) => adminPlaza?.empleado === empleado_id);
  //     const _plaza = plazas?.find((pl) => pl?.id === _adminPlaza?.plaza);
  //     const _puestoEmpleado = puestos?.find((p) => p?.id === _plaza?.puesto);
  //     const _tipoEmpleadoId = tiposDeEmpleados?.find((tne) => tne?.id === _puestoEmpleado?.tipo_empleado)?.id;
  //     form.setFieldValue('tipo_de_empleado', _tipoEmpleadoId);

  //     //* Puesto
  //     form.setFieldValue('puesto', _puestoEmpleado?.descripcion);

  //     //* Área
  //     const _areaEmpleado = areaBuscar(_plaza?.area_content_id, areas)?.tableTitle;
  //     form.setFieldValue('area', _areaEmpleado);

  //     //* No. Plaza
  //     const adminPlaza = administracionDePlazas?.find((plaza) => plaza.empleado === empleado_id);
  //     const clavePlaza = plazas?.find((plazaObject) => plazaObject.id === adminPlaza?.plaza)?.clave;
  //     form.setFieldValue('plaza', clavePlaza);

  //     //* Periodos de Nominas
  //     const periodoId = periodosDeNominas?.find((periodo) => periodo.tipo_de_nomina_empleado === tipo_de_nomina_empleado)?.id;
  //     const periodosNominas = periodosDeNominaDetalles?.filter((periodo) => periodo.periodo_de_nomina === periodoId);
  //     setPeriodosDeNominaDetallesFiltered(periodosNominas);
  //   }
  // };

  const setRetencionDePagoValues = async (retencionDePago) => {
    form.setFieldsValue(formatReceived(retencionDePago));
    const _empleado = await getEmpleado(retencionDePago?.empleado);
    form.setFieldValue(nameEmpleado, _empleado?.id);
    // setSelectedEmpleadoSearch(_empleado);
    // onChangeEmpleado(retencionDePago.empleado);
    form.setFieldValue('periodo_de_nomina_retenido', retencionDePago.periodo_de_nomina_retenido);
    form.setFieldValue('periodo_de_nomina_retencion', retencionDePago.periodo_de_nomina_retencion);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _retencionDePago = await getRetencionDePago(match.id);
    setTimeout(() => {
      if (_retencionDePago) {
        form.resetFields();
        setTimeout(() => {
          setRetencionDePagoValues(_retencionDePago);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
        // empleado: selectedEmpleadoSearch?.id,
      };
      const [key] = selectedRowKeys;
      const saved = await (key ? patchRetencionDePago(key, values) : postRetencionDePago(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const onClickModal = async () => {
    setOpenModal(true);
  };

  const onClickRetener = async () => {
    setOpenRetener(true);
  };

  const onRetener = async () => {
    try {
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        id: val, estado_retencion: ESTADO_PAGO_RETENIDO,
      }));
      const saved = await putRetencionesDePagos(mappedSelectedRowKeys);
      if (saved) {
        onCancel();
        await fetchData();
      }
    } catch (err) {
      onError(
        err,
        setLoading,
      );
    }
  };

  const onLiberarCancelar = async () => {
    try {
      await formModal.validateFields();
      const value = {
        ...formModal.getFieldsValue(),
      };
      let mappedSelectedRowKeys;
      if (canceladoLiberado) {
        mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
          // eslint-disable-next-line
          id: val, estado_retencion: ESTADO_PAGO_LIBERADO, fecha: value.fecha_liberacion_cancelacion, observaciones: value.observaciones,
        }));
        const saved = await putLiberacionesDePagos(mappedSelectedRowKeys);
        if (saved) {
          onCancel();
          await fetchData();
          formModal.resetFields();
        }
      } else {
        mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
          // eslint-disable-next-line
          id: val, estado_retencion: ESTADO_PAGO_CANCELADO, fecha: value.fecha_liberacion_cancelacion, observaciones: value.observaciones,
        }));
        const saved = await putCancelacionesDePagos(mappedSelectedRowKeys);
        if (saved) {
          onCancel();
          await fetchData();
          formModal.resetFields();
        }
      }
    } catch (err) {
      onError(
        err,
        formInstances,
      );
    }
  };

  const deleteMultipleRows = async () => {
    try {
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        id: val,
      }));
      const saved = await deleteRetencionesDePagos(mappedSelectedRowKeys);
      if (saved) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    } catch (err) {
      onError(
        err,
        setLoading,
      );
    }
  };

  const handleOnRowClick = (record) => {
    if (selectedRowKeys.includes(record.id)) {
      setSelectedRowKeys(selectedRowKeys.filter((id) => id !== record.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
    }
    if (selectedRowKeys.length < 1) {
      const selectedEmpleado = empleados?.find((empleado) => empleado.id === record.empleado);

      setClaveNombreEmpleado(`${selectedEmpleado?.numero_de_empleado} - ${selectedEmpleado?.nombre} ${selectedEmpleado?.apellido_paterno} ${selectedEmpleado?.apellido_materno || ''}`.toUpperCase());
      setSelectedRowKeys([record.id]);
      form.setFieldsValue(record);
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    type: 'checkbox',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onCancelImport = () => {
    setVisibleModal(false);
    formCarga.resetFields();
  };

  const onClickObtenerPlantilla = async () => {
    try {
      setLoading(true);
      const excel = await getRetencionDePagoPlantilla();
      if (excel) {
        const blob = new Blob([excel], {
          type: 'application/ms-excel',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'RetencionPagoEmpleado_Plantila.xlsx';
        link.click();
      }
      setLoading(false);
    } catch (err) {
      onError(err);
    }
  };

  const onClickCargar = () => {
    setVisibleModal(true);
  };

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);
        const uri = baseURI.at(-1) === '/' ? baseURI : `${baseURI}/`;
        const response = await HTTP.post(`${baseURL}${uri}`, formData, {
          headers: {
            'Content-Type': 'application/ms-excel',
          },
          responseType: 'arraybuffer',
        });
        if (response?.data) {
          const blob = new Blob([response?.data], {
            type: 'application/ms-excel',
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'RetencionPagoEmpleado_Respuesta.xlsx';
          link.click();
        }
        if (response?.status === 200) {
          onSuccess(response, 'Operación realizada correctamente', 5);
          await fetchData();
          onCancel();
        }
      }
      setLoading(false);
      setVisibleModal(false);
    } catch (err) {
      message.warn('Error al importar, datos no válidos.');
      onError(err, setLoading);
    }
  };

  const menuImport = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Obtener Plantilla',
          text: 'Obtener Plantilla',
          icon: <FileExcelOutlined />,
          onClick: () => onClickObtenerPlantilla(),
        },
        {
          key: 2,
          label: 'Cargar',
          text: 'Cargar',
          icon: <DownloadOutlined />,
          onClick: () => onClickCargar(),
        },
      ]}
    />
  );

  // const validateInput = async () => {
  //   setLoading(true);
  //   setSelectedEmpleadoSearch();
  //   const searchEmp = form.getFieldValue('empleado');
  //   if (!searchEmp) {
  //     setVisibleSearch(true);
  //     return setLoading(false);
  //   }
  //   const res = await getEmpleadosConDatosOpFilteredPaginated(`${baseURIDatosOpPaginado}numero_de_empleado=${searchEmp};`);
  //   const result = res?.results[0];
  //   if (!res) {
  //     return setLoading(false);
  //   }
  //   const empleadoResult = result?.empleado;
  //   setSelectedEmpleadoSearch(empleadoResult);
  //   if (empleadoResult) {
  //     form.setFieldsValue({
  //       empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
  //     });
  //   } else {
  //     form.resetFields(['empleado']);
  //   }
  //   onChangeEmpleado(empleadoResult?.id);
  //   return setLoading(false);
  // };

  // const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
  //   setLoading(true);
  //   if (empId) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}numero_de_empleado=${empId};`;
  //   }
  //   if (nombreEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}nombre=${nombreEmp};`;
  //   }
  //   if (apPatEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_paterno=${apPatEmp};`;
  //   }
  //   if (apMatEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_materno=${apMatEmp};`;
  //   }
  //   if (tipoNominaEmpleado) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
  //   }
  //   setBaseURIPagination(baseURIDatosOpPaginado);
  //   const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURIDatosOpPaginado);
  //   setDataSearch(_empleados);
  //   return setLoading(false);
  // };

  // const columnsEmpleado = [
  //   {
  //     titleText: 'No. de Empleado',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 200,
  //     render: (empObject) => empObject?.numero_de_empleado,
  //   },
  //   {
  //     titleText: 'Nombre',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.nombre,
  //   },
  //   {
  //     titleText: 'Apellido Paterno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_paterno,
  //   },
  //   {
  //     titleText: 'Apellido Materno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_materno,
  //   },
  //   {
  //     titleText: 'Puesto',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 300,
  //     render: (empObject) => {
  //       const adminPlazaEmp = administracionDePlazas?.find((admP) => admP?.empleado === empObject?.id);
  //       const plazaEmp = plazas?.find((pl) => pl?.id === adminPlazaEmp?.plaza);
  //       const puestoEmp = puestos?.find((p) => p?.id === plazaEmp?.puesto);
  //       return `${puestoEmp?.descripcion || ''}`;
  //     },
  //   },
  //   {
  //     titleText: 'Tipo de Nómina Empleado',
  //     dataIndex: 'tipo_de_nomina_empleado',
  //     key: 'tipo_de_nomina_empleado',
  //     width: 250,
  //     render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
  //   },
  // ];

  const columns = [
    {
      titleText: 'No. y Nombre de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 300,
      render: (val) => empleados?.find((e) => e.id === val)?.numero_y_nombre_completo,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (val) => {
        const { _plaza } = getPlaza(val);
        return _plaza?.tipo_nomina_empleado;
      },
    },
    {
      titleText: 'Puesto',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (val) => {
        const { _plaza } = getPlaza(val);
        return _plaza?.puesto_clave_y_descripcion;
      },
    },
    {
      titleText: 'Área',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (val) => {
        const { _plaza } = getPlaza(val);
        return _plaza?.directorio_area_clave_y_nombre;
      },
    },
    {
      titleText: 'Plaza',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (val) => {
        const { _plaza } = getPlaza(val);
        return _plaza?.clave_y_descripcion;
      },
    },
    {
      titleText: 'Motivo de Retención de Pago',
      dataIndex: 'motivo_de_retencion_de_pago',
      key: 'motivo_de_retencion_de_pago',
      width: 400,
      render: (id) => {
        const motivo = motivosDeRetencionDePagos.find((motivoDeRetencionDePago) => motivoDeRetencionDePago.id === id)?.motivo;
        return motivo;
      },
    },
    {
      titleText: 'Periodo de Nómina Retenido',
      dataIndex: 'periodo_de_nomina_retenido',
      key: 'periodo_de_nomina_retenido',
      width: 400,
      render: (val) => {
        const _periodo = periodosDeNominaDetalles.find((e) => e.id === val);
        return `${_periodo?.numero_de_nomina} (${_periodo?.fecha_inicial} - ${_periodo?.fecha_final})`;
      },
    },
    {
      titleText: 'Periodo de Nómina de Retención',
      dataIndex: 'periodo_de_nomina_retencion',
      key: 'periodo_de_nomina_retenido',
      width: 400,
      render: (val) => {
        const _periodo = periodosDeNominaDetalles.find((e) => e.id === val);
        return `${_periodo?.numero_de_nomina} (${_periodo?.fecha_inicial} - ${_periodo?.fecha_final})`;
      },
    },
    {
      titleText: 'Fecha de Liberación o Cancelación',
      dataIndex: 'fecha_liberacion_cancelacion',
      key: 'fecha_liberacion_cancelacion',
      width: 290,
      render: (val) => val?.format(),
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 300,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estado_retencion',
      key: 'estado_retencion',
      width: 150,
      render: (val) => estadosDeRetenciones.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    estatus: [requiredRule],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => onClickRetener(),
                text: 'Retener',
                icon: <MinusCircleOutlined />,
                disabled: !canRetener,
              },
              {
                onClick: () => onClickModal(setTitle(' Liberación'), setCanceladoLiberado(true)),
                text: 'Liberar',
                icon: <DollarOutlined />,
                disabled: !cancLib,
              },
              {
                permission: { model: 'retenciondepagoempleado', action: 'cancelar' },
                onClick: () => onClickModal(setTitle(' Cancelación'), setCanceladoLiberado(false)),
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                disabled: !cancLib,
              },
            ]}
            permission={permission}
            allowExportPDF={false}
            disableDelete={disableDelete}
            allowDoubleClick={false}
            allowCustomImport
            customImportMenu={menuImport}
            customImportText="Importar Retenciones"
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Retención de Pago`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                allowSave={!disableEdit}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
              style={{ paddingTop: '1rem' }}
              disabled={disableEdit}
            >
              <Row
                gutter={10}
                style={{ paddingBottom: '.1rem' }}
              >
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameEmpleado}
                    label="No. y Nombre del Empleado"
                    required
                    hasFeedback
                  >
                    <Select
                      labelProp="numero_y_nombre_completo"
                      dataSource={empleados}
                      disabled={selectedRowKeys?.length}
                    />
                  </Form.Item>
                </Col>
                {/* }{selectedEmpleadoSearch
                    ? (
                      form.setFieldsValue({
                        empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
                      })
                    ) : null} */}
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameTipoEmpleado}
                    label="Tipo de Empleado"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={namePuesto}
                    label="Puesto"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameArea}
                    label="Área"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={namePlaza}
                    label="No. de Plaza"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="motivo_de_retencion_de_pago"
                    label="Motivo de Retención de Pago"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      dataSource={motivosDeRetencionDePagos}
                      keyProp="id"
                      labelProp="motivo"
                      render={(val) => `${val?.clave} - ${val?.motivo}`}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="periodo_de_nomina_retenido"
                    label="Periodo de Nómina Retenido"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Select
                      dataSource={periodosDeNominaDetallesFiltered}
                      keyProp="id"
                      render={(periodoDeNominaDetalle) => `${periodoDeNominaDetalle.numero_de_nomina} (${periodoDeNominaDetalle.fecha_inicial} al ${periodoDeNominaDetalle.fecha_final})`}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="periodo_de_nomina_retencion"
                    label="Periodo de Nómina de Retención"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Select
                      dataSource={periodosDeNominaDetallesFiltered}
                      keyProp="id"
                      render={(periodoDeNominaDetalle) => `${periodoDeNominaDetalle.numero_de_nomina} (${periodoDeNominaDetalle.fecha_inicial} al ${periodoDeNominaDetalle.fecha_final})`}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_liberacion_cancelacion"
                    label="Fecha de Liberación o Cancelación"
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      placeholder=""
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Estatus"
                    name="estado_retencion"
                    rules={rules.estatus}
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      keyProp="id"
                      labelProp="descripcion"
                      dataSource={estadosDeRetenciones}
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteMultipleRows}
          onCancel={onCancel}
          onClickEdit={onClickEdit}
          open={visibleAlert}
          content={selectedRowKeys.length === 1 ? `Retención De Pago ${claveNombreEmpleado}` : `${selectedRowKeys.length} Retenciones De Pago?`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onRetener}
          onCancel={onCancel}
          contentTitle={selectedRowKeys.length === 1 ? 'Retener el Registro Seleccionado' : `Retener ${selectedRowKeys.length} Registros Seleccionados`}
          open={openRetener}
          ConfirmRetencion
        />
        <ModalFechaObservacion
          open={openModal}
          onCancel={onCancel}
          onPutDate={onLiberarCancelar}
          title={title}
          subTitle={title}
          fechaKey="fecha_liberacion_cancelacion"
          form={formModal}
        />
        {/* Modal de carga masiva */}
        <Modal
          open={visibleModal}
          title={(
            <FormSubmitControls
              label="Carga Masiva"
              onFinish={onUpload}
              onCancel={onCancelImport}
              loading={loading}
            />
          )}
          onCancel={onCancelImport}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name="carga"
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={rules.required}
                name="file"
                allowedExtensions={['xlsx']}
              />
            </Form>
          </Spin>
        </Modal>
        {/* <CustomSearch
          form={form}
          open={openSearch}
          setVisible={setVisibleSearch}
          modalTitle="Buscar Empleado"
          firstInputLabel="No. de Empleado"
          firstInputName="numero_de_empleado"
          secondInputLabel="Nombre del Empleado"
          secondInputName="nombre"
          searchInputLabel="Apellido Paterno"
          searchInputName="apellido_paterno"
          thirdInputLabel="Apellido Materno"
          thirdInputName="apellido_materno"
          firstSelectLabel="Tipo de Nómina Empleado"
          firstSelectName="tipo_de_nomina_empleado"
          firstSelectDataSource={tiposDeNominaEmpleado}
          inputsNeeded={3}
          selectsNeeded={1}
          paginatedTable
          modalWidth={1400}
          columns={columnsEmpleado}
          baseURI={baseURIPagination}
          setSelectedRow={setSelectedEmpleadoSearch}
          onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
          data={dataSearch}
          setData={setDataSearch}
          searchData={searchData}
          onChange={onChangeEmpleado}
        /> */}
      </Spin>
    </Row>
  );
};

export default NominasRetencionDePagos;
